import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import SitePage, { CallToAction, styles, T, ACCENT } from '../components/site/SitePage';

const OUTILS = [
  {
    to: '/outils/calcul-stock-de-securite',
    kicker: 'Stock et achats',
    titre: 'Calculateur de stock de sécurité et de point de commande',
    texte: 'Vos ventes Amazon, Shopify et B2B, le délai de votre fournisseur : combien garder en réserve, quand repasser commande et combien commander, minimum et colisage compris.',
    plus: 'Avec le modèle Excel complet : un onglet catalogue pour 50 produits.',
    action: 'Calculer mon stock de sécurité'
  },
  {
    to: '/outils/calcul-marge-amazon',
    kicker: 'Finance et marge',
    titre: 'Calculateur de marge Amazon, Shopify et B2B',
    texte: 'Ce que vous rapporte vraiment une vente sur Amazon, sur votre site et à un revendeur, une fois la commission, la logistique, les remises, les retours et la publicité payés.',
    plus: 'Avec le seuil de publicité au-delà duquel vous vendez à perte.',
    action: 'Calculer ma marge'
  }
];

const OutilsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SitePage>
      <SEO
        title="Outils gratuits pour les marques e-commerce"
        description="Calculateurs gratuits pour les marques qui vendent sur Amazon et Shopify : stock de sécurité, point de commande, marge réelle par canal. Sans inscription."
        path="/outils"
        breadcrumb={[['Outils gratuits', '/outils']]}
      />

      <section style={{ ...styles.container, padding: '56px 24px 0', display: 'flex', flexDirection: 'column', gap: 16 }}>
        <p style={styles.kicker}>Gratuits · sans inscription</p>
        <h1 style={{ ...styles.h1, maxWidth: 860 }}>Outils gratuits pour les marques e-commerce</h1>
        <p style={{ ...styles.lead, maxWidth: 720 }}>Les calculs que je fais pour les équipes e-commerce, en libre accès. Ils tournent dans votre navigateur : vos chiffres ne partent nulle part, sauf si vous demandez le modèle Excel par e-mail.</p>
      </section>

      <section style={{ ...styles.container, paddingTop: 40 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(380px, 100%), 1fr))', gap: 20 }}>
          {OUTILS.map((o) => (
            <Link key={o.to} to={o.to} className="lift" style={{ background: '#FFFFFF', border: `1px solid ${T.line2}`, borderRadius: 10, padding: 28, display: 'flex', flexDirection: 'column', gap: 12, color: T.ink, textDecoration: 'none' }}>
              <span style={{ fontFamily: T.mono, fontSize: 13, color: ACCENT }}>{o.kicker}</span>
              <span style={{ fontSize: 26, fontWeight: 800, fontStretch: '82%', lineHeight: 1.1 }}>{o.titre}</span>
              <span style={{ fontSize: 16, color: T.text, lineHeight: 1.55 }}>{o.texte}</span>
              <span style={{ fontSize: 15, color: T.muted }}>{o.plus}</span>
              <span style={{ marginTop: 'auto', paddingTop: 8, fontWeight: 700, color: ACCENT }}>{o.action} →</span>
            </Link>
          ))}
        </div>
        <p style={{ margin: '28px 0 0', fontSize: 17, color: T.text }}>Vous utilisiez Stocky sur Shopify ? Lisez <Link to="/alternative-stocky">les alternatives à Stocky</Link>, fermé le 31 août 2026.</p>
      </section>

      <CallToAction from="outils" title="Ces calculs, sur tout votre catalogue ?" text="30 minutes pour voir ce qu'un outil sur mesure ferait chez vous, chaque semaine et avec vos vraies données." />
    </SitePage>
  );
};

export default OutilsPage;
